//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash/debounce';
import { Menu, Button, Spin } from "ant-design-vue";
import "ant-design-vue/es/dropdown/style/index.css"
import "ant-design-vue/es/menu/style/index.css"
import MenuItem from "ant-design-vue/lib/menu/MenuItem.js";
import HeaderMenuDrawer from "~/components/objects/HeaderMenuDrawer.vue";
import HeaderMenuCategories from "~/components/objects/HeaderMenuCategories.vue";
import TheRadarIcon from "@/components/TheRadarIcon.vue"
import HeaderUserBlock from "@/components/base/HeaderUserBlock.vue"
// import VistatLogoAnimated from "@/components/base/VistatLogoAnimated.vue"

export default {
  name: "TheNewHeader",
  components: {
    'a-menu': Menu,
    'a-menu-item': MenuItem,
    'a-button': Button,
    'a-spin': Spin,
    HeaderMenuDrawer,
    HeaderMenuCategories,
    TheRadarIcon,
    HeaderUserBlock,
    // VistatLogoAnimated,
  },
  data() {
    return {
      showSearchBox: false,
      nothingFound: false,
      findArticles: [],
      findObjects: [],
      searchInProgress: false,
      query: this.$route.query.q || '',
      openMobileNavState: false,
      openMobileSearchState: false,
      availablePermission: ['A', 'CA', 'CE'],
      headerMenu: {
        articles: {
          icon: "menu-articles",
          label: "Статьи",
          url: "/art"
        },
        objects: {
          icon: "menu-objects",
          label: "Энциклопедия",
          url: "/objects"
        },
        // about: {
        //   icon: "menu-about",
        //   label: "О проекте",
        //   url: "/"
        // }
      },
      customSearchDropdownStyle:{
        //width: 'fit-content',
      },
    }
  },
  computed: {
    showAvailable() {
      return this.availablePermission.includes(this.$auth.user.role)
    },
    isStaging() {
      return process.env.isStaging
    },
    isStagingDev1() {
      return process.env.isStagingDev1
    },
    buildVersion() {
      return process.env.buildVersion
    },
    getName() {
      return this.$auth.user.profile.nickname ?? this.$auth.user.username
    },
    searchGroups() {
      const groups = []

      if (this.findArticles.length) {
        groups.push({
          key: 'articles',
          title: 'Статьи',
          items: this.findArticles.map(article => ({
            id: article.id,
            label: article.label,
            fuzzy: false,
            to: {
              name: article.is_spec_project ? 'sp-slug' : 'art-slug',
              params: { slug: article.slug },
            },
          })),
        })
      }

      if (this.findObjects.length) {
        groups.push({
          key: 'objects',
          title: 'Энциклопедия',
          items: this.findObjects.map(object => ({
            id: object.id,
            label: object.label,
            fuzzy: object.fuzzy,
            to: {
              name: 'objects-slug',
              params: { slug: object.slug },
            },
          })),
        })
      }

      return groups
    },
  },
  watch: {
    '$route'() {
      if (this.showSearchBox) {
        this.hideSuggestBox()
      }
    }
  },
  methods: {
    fetchSearchResults: async function () {
      this.searchInProgress = true

      const [articlesResponse, objects] = await Promise.all([
        this.$store.dispatch('art/publicMaterialsSearch', {
          q: this.query,
          limit: 5,
          offset: 0,
          order: '-total_score',
          skipEnrich: true,
        }).catch(() => ({ items: [] })),
        this.$store.dispatch('objects/publicSearch', {
          q: this.query,
          is_my: this.$route.name === 'my' ? 1 : 0,
          order: '-total_score',
          limit: 5,
        }).catch(() => []),
      ])

      this.findArticles = articlesResponse.items || []
      this.findObjects = objects
      this.nothingFound = !this.findArticles.length && !this.findObjects.length
      this.searchInProgress = false
    },
    debounceSearchWrapper: debounce(function () {
      this.fetchSearchResults()
    }, 200),
    handleSearchInput() {
      if (this.query.length >= 3) {
        this.showSearchBox = true
        this.debounceSearchWrapper()
      } else {
        this.hideSuggestBox()
      }
    },
    handleSearch(value) {
      this.query = value

      this.handleSearchInput()
    },
    handleFocusOut(evt, delay = 250) {
      if (evt.relatedTarget && evt.relatedTarget.classList.contains('header__search-box__link')) return

      setTimeout(() => {
        this.query = ""
        this.hideSuggestBox()
      }, delay)
    },
    handleFocusIn() {
      this.handleSearchInput(this.query)
    },
    hideSuggestBox() {
      this.showSearchBox = false
      this.nothingFound = false
      this.findArticles = []
      this.findObjects = []
    },
    goToSearch() {
      if (this.query.length < 3) return

      const isSearchPage = this.$route.name === 'search'
      const searchQuery = isSearchPage
        ? { q: this.query, tab: this.$route.query.tab || 'objects' }
        : { q: this.query }

      if (['search', 'my'].includes(this.$route.name)) {
        if (this.$route.query.q === this.query && (!isSearchPage || this.$route.query.tab === searchQuery.tab)) return

        this.$router.replace({ query: searchQuery })
      } else {
        this.$router.push({
          name: 'search',
          query: { q: this.query, tab: 'objects' },
        })
      }

      this.hideSuggestBox()
    },
    getTotalCount(typeMenu) {
      var res = null;

      switch (typeMenu) {
      case "articles":
        res = this.$store.getters['async_fetch_data/getTotalCountArts']
        break;
      case "objects":
        res = this.$store.getters['async_fetch_data/getTotalCountObjects']
        break;
      }

      return res;
    }
  },
}
